import { render, staticRenderFns } from "./AwardEditLayer.vue?vue&type=template&id=8eaf225a&scoped=true&"
import script from "./AwardEditLayer.vue?vue&type=script&lang=js&"
export * from "./AwardEditLayer.vue?vue&type=script&lang=js&"
import style0 from "./AwardEditLayer.vue?vue&type=style&index=0&id=8eaf225a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaf225a",
  null
  
)

export default component.exports